
/* https://gomakethings.com/how-to-check-if-something-is-an-object-with-vanilla-javascript/ */
function isPlainObject(obj) {
	return Object.prototype.toString.call(obj) === '[object Object]';
};

function replaceUnknowns(data, unknowns) {
	if (typeof data === 'string') {
		for ([unknown_, num] of Object.entries(unknowns)) {
			if (data.split(",")[0] == unknown_) {
				return num;
			}
		}
		return data;
	} else if (Array.isArray(data)) {
		return data.map(x => replaceUnknowns(x, unknowns));
	} else if (isPlainObject(data)) {
		return Object.fromEntries(Object.entries(data)
					.map(([key, val]) => [key, replaceUnknowns(val, unknowns)]));
	}
	else {
		return data;
	}
}

module.exports = replaceUnknowns;